import React, { useRef } from 'react'
import Slider from 'react-slick';

function Features({ handleOpen }) {
    const slideRef = useRef()
    const arrowAction = (type) => {
        console.log("slideRef", slideRef);
        if (type == "left") {
            if (slideRef.current) {
                slideRef.current.slickPrev()
            }
        } else {
            if (slideRef.current) {
                slideRef.current.slickNext()
            }
        }
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };



    return (
        <section className="py-3 my-3 text-center container featuresSlider" id='features'>
            <div className='pb-3 d-flex justify-content-between'>
                <h2 className="m-0 py-3">Features that Help you build better</h2>
                <div className="slider-btns">
                    <span className="slide-left" onClick={() => { arrowAction("left") }}>
                        <i className="fa fa-angle-left" aria-hidden="true"></i>
                    </span>
                    <span className="slide-right" onClick={() => { arrowAction("right") }}>
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </div>
            </div>
            {
                <Slider {...settings} className="testimonial-slider" ref={slideRef}>

                    <div className="faq-container flex-column" data-aos="fade-up">
                        <div className='w-100 '>
                            <div className='row'>
                                <div className='col-md-6  text-start'>
                                    <div>
                                        <p className="text-secondary mb-2">
                                            📊 <strong>Analytics & Reporting</strong>
                                        </p>
                                        <h2 className="fw-bold text-dark">Build Your Team, Grow Your Excellence</h2>
                                        <p className="text-muted">
                                            Streamline HR processes and empower your team with our products.
                                            Facilitate managing employee data, and more in one platform.
                                        </p>

                                        <ul className="list-unstyled">
                                            {[
                                                "Enables HR professionals to make informed decisions based on real-time data insights.",
                                                "Helps track key performance indicators to measure the effectiveness of HR strategies.",
                                                "Assists in monitoring compliance with regulations and identifying potential risks.",
                                                "Graphs and heat maps to present data visually, making it easier to analyze trends and patterns.",
                                                "Reports for essential HR metrics, turnover rates, employee demographics, and performances."
                                            ].map((item, index) => (
                                                <li key={index} className="d-flex align-items-center mb-2 text-dark">
                                                    <i className="fa fa-check text-success me-2" aria-hidden="true"></i>
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>

                                        <button onClick={() => { handleOpen() }} className="req-btn my-2">
                                            Book a Demo
                                            <svg width="18" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                                        </button>
                                    </div>

                                </div>
                                <div className='col-md-6'>
                                    <div className='text-end'>
                                        <img src='/assets/img/featurenew.png' className='img-fluid' />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="faq-container flex-column" data-aos="fade-up">
                        <div className='w-100 '>
                            <div className='row'>

                                <div className='col-md-6'>
                                    <div className='text-end'>
                                        <img src='/assets/img/EmployeStatus.png' className='img-fluid' />
                                    </div>
                                </div>

                                <div className='col-md-6 text-start d-flex align-items-center '>
                                    <div>
                                        <p className="text-secondary mb-2">
                                            <i className='fa fa-calender' />
                                            <strong>Employee & Payroll
                                            </strong>
                                        </p>
                                        <h2 className="fw-bold text-dark">Employee & Payroll
                                            <br />
                                            Management</h2>
                                        <p className="text-muted">
                                            Centralized database for employee profiles, including personal details, roles, &  performance records.
                                        </p>


                                        <button onClick={() => { handleOpen() }} className="req-btn my-2">
                                            Book a Demo
                                            <svg width="18" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="faq-container flex-column" data-aos="fade-up">
                        <div className='w-100 '>
                            <div className='row'>


                                <div className='col-md-6 text-start d-flex align-items-center '>
                                    <div>
                                        <p className="text-secondary mb-2">
                                            <i className='fa fa-calender' />
                                            <strong>Customers & Payments
                                            </strong>
                                        </p>
                                        <h2 className="fw-bold text-dark">Customer & Payment
                                            <br />
                                            Management</h2>
                                        <p className="text-muted">
                                            Centralized customer profiles with integrated payment tracking for seamless relationship and financial management                                        </p>
                                        <button onClick={() => { handleOpen() }} className="req-btn my-2">
                                            Book a Demo
                                            <svg width="18" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                                        </button>
                                    </div>

                                </div>
                                <div className='col-md-6'>
                                    <div className='text-end'>
                                        <img src='/assets/img/Invoice.png' className='img-fluid' />
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>


                </Slider>
            }
        </section>
    )
}

export default Features
